// Update ProcedureType to match database schema
export interface ProcedureType {
  id: string;
  slug: string;
  name: string;
  category: string;
  description?: string | null;
  display_order: number;
}

// Map specialty slugs from database to backend enum values
export const SPECIALTY_SLUG_TO_ENUM_MAPPING: Record<string, string> = {
  // Active slugs
  'vascular': 'vascular',
  'fertility': 'fertility',
  'hair-transplant': 'hair_transplant',
  'hair_transplant': 'hair_transplant',
  'plastic-surgery': 'plastic_surgery',
  'diagnostics-imaging': 'diagnostics_imaging',
  'dentistry': 'dentistry',
  'optical': 'optical',
  // Legacy slugs mapped to the new enums
  'cosmetic-surgery': 'plastic_surgery',
  'cosmetic': 'plastic_surgery',
  'diagnosis-testing': 'diagnostics_imaging',
  'diagnosis_testing': 'diagnostics_imaging',
  'optics': 'optical',
  'general-medicine': 'diagnostics_imaging',
  'general': 'diagnostics_imaging',
};

// Legacy category mapping for backward compatibility (if needed)
export type SpecialtyCategory = 
  | 'vascular'
  | 'fertility'
  | 'hair-transplant'
  | 'plastic-surgery'
  | 'diagnostics-imaging'
  | 'dentistry'
  | 'optical';

// Legacy mapping kept for backward compatibility but deprecated
export const SPECIALTY_TAG_MAPPING: Record<string, string> = {
  'vascular': 'vascular',
  'fertility': 'fertility',
  'hair-transplant': 'hair_transplant',
  'plastic-surgery': 'plastic_surgery',
  'diagnostics-imaging': 'diagnostics_imaging',
  'dentistry': 'dentistry',
  'optical': 'optical',
};

// Category display names (kept for backward compatibility)
export const CATEGORY_LABELS: Record<string, string> = {
  'vascular': 'Vascular',
  'fertility': 'Fertility',
  'hair-transplant': 'Hair Transplant',
  'plastic-surgery': 'Plastic Surgery',
  'diagnostics-imaging': 'Diagnostics / Imaging',
  'dentistry': 'Dentistry',
  'optical': 'Optical',
};

/**
 * Maps a specialty slug to the backend enum value
 * @param slug - The specialty slug from the database
 * @returns The backend enum value, defaults to 'general' if not found
 */
export function mapSpecialtySlugToEnum(slug: string): string {
  return SPECIALTY_SLUG_TO_ENUM_MAPPING[slug] || 'dentistry';
}

/**
 * Helper function to get specialty tag for API from a ProcedureType
 * @param procedure - The selected procedure/specialty
 * @returns The backend enum value for the specialty
 */
export function getSpecialtyTag(procedure: ProcedureType | string | null | undefined): string {
  if (!procedure) return 'dentistry';
  
  // If it's a string (slug), map it directly
  if (typeof procedure === 'string') {
    return mapSpecialtySlugToEnum(procedure);
  }
  
  // If it's a ProcedureType object, use the slug
  if (procedure.slug) {
    return mapSpecialtySlugToEnum(procedure.slug);
  }
  
  // Fallback to general
  return 'dentistry';
}

// Legacy exports - deprecated but kept for compatibility
export const ALL_PROCEDURES: ProcedureType[] = []; // Empty - will be populated from API
